import {scaleLinear} from 'd3-scale';
import {Colours} from '@learningblocks/storybook-components';

const PERCENTAGE = {
  HALF: 50,
  MIN: 0,
  MAX: 100,
};

export function getSliderStyle({min, max, value}) {
  let selectedPercentage = scaleLinear()
    .domain([min, max])
    .range([PERCENTAGE.MIN, PERCENTAGE.MAX])(value);
  let background = Colours.colorPrimaryTone80;
  if (selectedPercentage > PERCENTAGE.HALF) {
    background = `linear-gradient(to right, ${
      Colours.colorSecondaryBlue
    } ${selectedPercentage}%, ${Colours.colorPrimaryTone80} ${
      PERCENTAGE.MAX - selectedPercentage
    }%)`;
  } else {
    background = `linear-gradient(to left, ${Colours.colorPrimaryTone80} ${
      PERCENTAGE.MAX - selectedPercentage
    }%,  ${Colours.colorSecondaryBlue} ${selectedPercentage}% )`;
  }
  return {background};
}
